export default function handleResponse (response) {

    return response.text().then(text => {
        const data = text && JSON.parse(text);
        console.log('response.ok: ', response.ok);
        console.log('response data: ', data);
        if (!response.ok) {
            if (response.status === 401) {
                // auto logout if 401 response returned from api
                //logout();
                //window.location.reload(true);
            }

            const error = (data && data.message) || response.statusText;
            return Promise.reject(error);
        }
        
        return data;
    });
}